import React from 'react';
import { resolveMediaPath } from '@/shared/libs/resolve-media-path';
import { Box } from '@/shared/ui/box';
import { useBrandTheme } from '@/shared/hooks';

type ImageProps = {
  src: string;
  alt: string;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  style?: React.CSSProperties;
  className?: string;
  width?: string | number;
  height?: string | number;
  fallback?: React.ReactNode;
};

const DefaultFallbackImage = ({
  width,
  height,
  style,
}: {
  width?: string | number;
  height?: string | number;
  style?: React.CSSProperties;
}) =>{
  const { assets:{loader} } = useBrandTheme();
  
  return <img
    src={window.innerHeight <= 768 ?loader?.mobile:loader?.default}
    alt="default-image"
    width={width}
    height={height}
    style={{
      objectFit: 'cover',
      ...style,
    }}
    loading="lazy"
  />
} 

const Image = React.memo(
  React.forwardRef<HTMLDivElement, ImageProps>(
    (
      {
        src,
        alt,
        onClick,
        style,
        className,
        width,
        height,
        styleForBox,
        fallback = (
          <DefaultFallbackImage width={width} height={height} style={style} />
        ),
        ...props
      },
      ref
    ) => {
      const [hasError, setHasError] = React.useState(false);

      React.useEffect(() => {
        setHasError(false);
      }, [src]);

      return (
        <Box
          ref={ref}
          className={className}
          onClick={onClick}
          {...props}
          style={styleForBox}
        >
          {hasError ? (
            fallback
          ) : (
            <img
              src={resolveMediaPath(src)}
              alt={alt}
              width={width}
              height={height}
              style={style}
              loading="lazy"
              onError={() => setHasError(true)}
            />
          )}
        </Box>
      );
    }
  )
);

export { Image };
